module.exports = __webpack_public_path__ + "157ee2aecc9f35e7241791744bd1155e.svg";